/* @flow */
import * as React from 'react';
import Dialog from 'components/Dialog';
import Image from 'components/Image';
import Text from 'components/Text';
import Heading from 'components/Heading';

type PartnerIntegrationModalProps = {
  integration: any,
  onRequestHide: Function,
};

const PartnerIntegrationModal = (props: PartnerIntegrationModalProps) => {
  const image = (() => {
    // prettier-ignore
    switch (props.integration.providerKey) {
      case 'canvas':             return require('assets/images/aci/canvas.png');
      case 'quizlet':            return require('assets/images/aci/quizlet.png');
      case 'schoology':          return require('assets/images/aci/schoology.png');
      case 'google_drive':       return require('assets/images/aci/google_drive.png');
      case 'google_classroom':   return require('assets/images/aci/google_classroom.png');
      case 'microsoft_onedrive': return require('assets/images/aci/onedrive.png');
      default:                   return require('assets/images/aci/canvas.png');
    }
  })();

  return (
    <Dialog onRequestHide={props.onRequestHide} className="AdminIntegratedToolsView-partnerModal">
      <div className="AdminIntegratedToolsView-partnerModal-hero">
        <Image src={image} />
      </div>
      <div className="AdminIntegratedToolsView-partnerModal-content">
        <div className="AdminIntegratedToolsView-partnerModal-content-logoContainer">
          <div className="AdminIntegratedToolsView-partnerModal-content-logoContainer-logo">
            <Image src={props.integration.iconURL} />
          </div>
        </div>
        <div className="AdminIntegratedToolsView-partnerModal-content-status">
          <Text color="koala" size="xsmall">
            Enabled for your organization!
          </Text>
        </div>
        <Heading levelStyle="1">{props.integration.title}</Heading>
        <Text>{props.integration.productLongDescription}</Text>
      </div>
    </Dialog>
  );
};

export default PartnerIntegrationModal;
